import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart as faHeartSolid } from "@fortawesome/free-solid-svg-icons";
import { faHeart as faHeartRegular } from "@fortawesome/free-regular-svg-icons";
import { IoIosHeart, IoIosHeartEmpty } from "react-icons/io";
import styles from "../../styles/Like.module.css";
import { toast } from "react-toastify";
import axios from "axios";

function Like({ postId, userLike, isOwner }) {
  const [like, setLike] = useState(userLike);
  const [loading, setLoading] = useState(false);
  const [likeCount, setLikeCount] = useState(0); // Stato per il conteggio dei like

  const ownerLikeClick = () => {
    toast.error("Non puoi darti il like, o furbo!!!", {
      position: "top-center", // Posizione del toast
      autoClose: 3000, // Durata del toast
      hideProgressBar: false, // Barra di progresso
      closeOnClick: true, // Chiudi al clic
      pauseOnHover: true, // Metti in pausa il timeout al passaggio del mouse
      draggable: true, // Permetti di trascinare il toast
    });
  };

  // Effetto per ricaricare lo stato del like e il conteggio
  useEffect(() => {
    const fetchLikeData = async () => {
      setLoading(true); // Inizia il caricamento
      try {
        // Recupera lo stato del like per l'utente e il conteggio totale
        let response = await axios.get(
          process.env.REACT_APP_SERVER_URL + "postsLikes/${postId}",
          {
            headers: {
              authToken: localStorage.getItem("AuthToken"),
            },
          }
        );

        if (response.data.like !== undefined) {
          setLike(response.data.like); // Imposta lo stato del like con il valore dal backend
        }
        setLikeCount(response.data.totalLikes); // Imposta il conteggio dei like
      } catch (error) {
        console.error(
          "Errore durante il recupero dello stato del like o del conteggio:",
          error
        );
      } finally {
        setLoading(false); // Fine caricamento
      }
    };

    fetchLikeData();
  }, [postId]);

  const changeLikes = async () => {
    try {
      let response = await axios.post(
        process.env.REACT_APP_SERVER_URL + "postsLikes",
        {
          like: !like,
          postId: postId,
        },
        {
          headers: {
            authToken: localStorage.getItem("AuthToken"),
          },
        }
      );

      setLike(!like); // Cambia lo stato del like dopo la risposta
      setLikeCount(response.data.totalLikes); // Aggiorna il conteggio dei like
    } catch (error) {
      console.error("Errore nell'aggiornamento del like:", error);
    }
  };

  // Se è in caricamento, mostra un indicatore o placeholder
  if (loading) {
    return <div>Caricamento...</div>;
  }

  return (
    <div className={styles.like}>
      <div className={styles.numlike}>
        <button
          type="button"
          onClick={() => {
            if (isOwner) {
              ownerLikeClick(); // Mostra il toast se l'utente è il proprietario
            } else {
              changeLikes(); // Cambia il like se non è il proprietario
            }
          }}
          title="Like"
          style={{
            backgroundColor: like ? "#fffff" : "#fffff", // Mantieni lo stesso colore per sfondo
          }}
        >
          <FontAwesomeIcon
            icon={like ? faHeartSolid : faHeartRegular} // Usa il cuore pieno se like è true, altrimenti vuoto
            style={{
              color: "red", // Imposta il colore sempre su rosso
              fontSize: "12pt", // Imposta la dimensione del font a 12pt
            }}
          />
          <span style={{ marginLeft: "8px" }}>{likeCount}</span>{" "}
          {/* Mostra il conteggio dei like */}
        </button>
      </div>
    </div>
  );
}

export default Like;
